import ReassignZendeskTicketDisclaimer from "./ReassignZendeskTicketDisclaimer.component.jsx";

export default ReassignZendeskTicketDisclaimer;
